<div
  id="styleSelector"
  class="menu-styler hidden"
>
  <div class="style-toggler">
    <a
      href="javascript:"
      title="customized"
    ></a>
  </div>
  <div class="style-block">
    <h5 class="mb-2">Gradient Able Live Customizer</h5>
    <hr class="my-0" />
    <div class="m-style-scroller">
      <h6>Layouts</h6>
      <div class="theme-color layout-type">
        <a
          href="javascript:"
          title="Menu Dark"
          data-value="menu-dark"
          ><span></span><span></span
        ></a>
        <a
          href="javascript:"
          title="Menu Light"
          data-value="menu-light"
          ><span></span><span></span
        ></a>
        <a
          href="javascript:"
          title="Dark Mode"
          data-value="dark"
          ><span></span><span></span
        ></a>
        <a
          href="javascript:"
          title="Reset"
          data-value="reset"
          >Reset to Default</a
        >
      </div>
      <h6>header background</h6>
      <div class="theme-color header-color">
        <a
          href="javascript:"
          title="Header Blue"
          data-value="header-blue"
          ><span></span><span></span
        ></a>
        <a
          href="javascript:"
          title="Header Red"
          data-value="header-red"
          ><span></span><span></span
        ></a>
        <a
          href="javascript:"
          title="Header Purple"
          data-value="header-purple"
          ><span></span><span></span
        ></a>
        <a
          href="javascript:"
          title="Header Info"
          data-value="header-info"
          ><span></span><span></span
        ></a>
        <a
          href="javascript:"
          title="Header Dark"
          ><span></span><span></span
        ></a>
        <a
          href="javascript:"
          title="Header Orange"
          data-value="header-orange"
          ><span></span><span></span
        ></a>
        <a
          href="javascript:"
          title="Header Green"
          data-value="header-green"
          ><span></span><span></span
        ></a>
        <a
          href="javascript:"
          title="Header Yellow"
          data-value="header-yellow"
          ><span></span><span></span
        ></a>
        <a
          href="javascript:"
          title="Header orchidGreen"
          data-value="header-orchidGreen"
          ><span></span><span></span
        ></a>
        <a
          href="javascript:"
          title="Header indigoGreen"
          data-value="header-indigoGreen"
          ><span></span><span></span
        ></a>
        <a
          href="javascript:"
          title="Header darkGreen"
          ><span></span><span></span
        ></a>
        <a
          href="javascript:"
          title="Header darkblue"
          data-value="header-darkblue"
          ><span></span><span></span
        ></a>
      </div>
      <div class="form-group mb-0">
        <div class="switch switch-primary d-inline m-r-10">
          <input
            type="checkbox"
            title="Rtl Theme"
            id="theme-rtl"
          />
          <label
            for="theme-rtl"
            class="cr"
          ></label>
        </div>
        <label>RTL</label>
      </div>
      <div
        class="form-group mb-0"
        *ngIf=""
      >
        <div class="switch switch-primary d-inline m-r-10">
          <input
            type="checkbox"
            title="Menu Fixed"
            id="menu-fixed"
            [(ngModel)]="menuFixedLayout"
            (change)="setMenuFixedLayout($event)"
          />
          <label
            for="menu-fixed"
            class="cr"
          ></label>
        </div>
        <label>Menu Fixed</label>
      </div>
      <div
        class="form-group mb-0"
        *ngIf=""
      >
        <div class="switch switch-primary d-inline m-r-10">
          <input
            type="checkbox"
            title="Header Fixed"
            id="header-fixed"
            [(ngModel)]="headerFixedLayout"
            (change)="setHeaderFixedLayout($event)"
          />
          <label
            for="header-fixed"
            class="cr"
          ></label>
        </div>
        <label>Header Fixed</label>
      </div>
      <div class="form-group mb-0">
        <div class="switch switch-primary d-inline m-r-10">
          <input
            type="checkbox"
            title="Box Layouts"
            id="box-layouts"
            (change)="setBoxLayout($event)"
          />
          <label
            for="box-layouts"
            class="cr"
          ></label>
        </div>
        <label>Box Layouts</label>
      </div>
    </div>
  </div>
</div>
